// extracted by mini-css-extract-plugin
export default {"header":"Analytics_header__VFFSW"};